"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearExportReport = exports.exportReportFailure = exports.exportReportSuccess = exports.exportReportRequest = void 0;
const ExportReportActionTypes = require("../../actionTypes/reports/export");
const exportReportRequest = (payload) => ({
    type: ExportReportActionTypes.EXPORT_REPORT_REQUEST,
    payload
});
exports.exportReportRequest = exportReportRequest;
const exportReportSuccess = () => ({
    type: ExportReportActionTypes.EXPORT_REPORT_SUCCESS
});
exports.exportReportSuccess = exportReportSuccess;
const exportReportFailure = (payload) => ({
    type: ExportReportActionTypes.EXPORT_REPORT_FAILURE,
    payload
});
exports.exportReportFailure = exportReportFailure;
const clearExportReport = () => ({
    type: ExportReportActionTypes.CLEAR_EXPORT_REPORT
});
exports.clearExportReport = clearExportReport;
//# sourceMappingURL=export.js.map